import React from "react";
import { Row, Col } from "reactstrap";
import { Link, Element } from "react-scroll";

import SealAndTitle from "./Home/SealAndTitle";
import PasswordResetForm from "./PasswordReset/PasswordResetForm";
import Footer from "./Home/Footer";

import "./Home/style/home.css";

import courtSeal from "./Home/images/CourtSeal-no-back.png";

const PasswordReset = (props) => {
  return (
    <React.Fragment>
      <Row className="largeHero">
        <Col xs={12} className="opaqueHeroSection">
          <Element name="top" />
          <SealAndTitle courtSeal={courtSeal} />
        </Col>
      </Row>
      <Row className="d-flex justify-content-center">
        <Col xs={10}>
          {props.match.params.token}
          <PasswordResetForm />
        </Col>
      </Row>

      <Row className="d-flex justify-content-center">
        <Col xs={12}>
          <Footer ScrollLink={Link} psInfo={true} />
        </Col>
      </Row>
    </React.Fragment>
  );
};
export default PasswordReset;
